import React from 'react';
import { Box, Typography } from '@material-ui/core';

import stylesMaterial from './stylesMaterial';

interface TableCaptionProps {
  color: string;
  caption: string;
}

export function TableCaption({ color, caption }: TableCaptionProps) {
  const classes = stylesMaterial();

  return (
    <Box className={classes.container}>
      <Box
        id={`color-box-${color}`}
        style={{ backgroundColor: color }}
        className={classes.colorBox}
      />
      <Typography
        component="label"
        htmlFor={`color-box-${color}`}
        className={classes.caption}
      >
        {caption}
      </Typography>
    </Box>
  );
}
